export const isMobile = {
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	}
};
